import apiConfig from "constants/apiConfig";
import { MediaProductType } from "types/influencer";
// import { InfluencerInsights, Posts } from "types/influencer";
import axiosClient from "utils/axiosClient";

// export const fetchInfluencerInsights = async (agencyId: string, influencerId: string): Promise<InfluencerInsights> => {
//     const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_INSIGHTS.url.replace('<agencyId>', agencyId)
//         .replace('<influencerId>', influencerId)
//     )
//     return response.data;
// }

export const fetchPost = async (hubId: string, influencerId: string, postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_POST.url.replace('<hubId>', hubId)
        .replace('<influencerId>', influencerId)
        .replace('<postId>', postId)
    )
    return response.data.post;
}

export const fetchBasicPost = async (postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_BASIC_POST.url.replace('<postId>', postId))
    return response.data.post;
}

// export const fetchMedia = async (agencyId: string, influencerId: string, payload: any = {}) : Promise<Posts> => {
//     const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_MEDIA.url.replace('<agencyId>', agencyId)
//     .replace('<influencerId>', influencerId), {params: {...payload, limit: 15, sort: 'like_count' }});

//     return response.data;
// }


export const fetchBasicSocialPost = async (hubId: string, postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_BASIC_SOCIAL_POST.url
        .replace('<hubId>', hubId)
        .replace('<postId>', postId)
    )
    return response.data.social_post;
}

export const fetchSocialPost = async (hubId: string, socialAccountId: string, socialPostId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POST.url
        .replace('<hubId>', hubId)
        .replace('<socialAccountId>', socialAccountId)
        .replace('<socialPostId>', socialPostId)
    )
    return response.data.social_post;
}


export const fetchSocialPosts = async (hubId: string, socialAccountId: string, type: MediaProductType, page: number)  => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POSTS.url.replace('<hubId>', hubId).replace('<socialAccountId>', socialAccountId), { params: { type, page, sort: 'timestamp_tz' } });
    return response.data;
}
